import Container from 'react-bootstrap/Container'
import './lastFooter.scss'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation} from "react-i18next";

export default function LastFooter() {
    const {t} = useTranslation();

    return (
        <Container fluid className='lastFooter'>
            <Row className='p-5 text-center'>
                <Col xs={12} md={6}>
                    <p>Copyright 2025 <strong className="text-white">ROMER</strong>. All rights reserved.</p>
                </Col>
                <Col xs={12} md={6}>
                    <p>
                        {t('footer.our_partners')}
                        <img src="/tpl/assets/img/efls.jpg" className={'ms-3'}/>
                        <img src="/tpl/assets/img/lp.jpg"/>
                    </p>
                </Col>
            </Row>
        </Container>
    )
}